import moment from 'moment';

export const VideoDateFormated = (cellContent, row, rowIndex, dIndexName) => (
  // console.log(row, dIndexName, row[dIndexName.dIndexName], 'dIndexName')
    
  dIndexName && dIndexName.dIndexName ? row[dIndexName.dIndexName] ? moment(row[dIndexName.dIndexName]).format('lll') : '-' : '-'
  
);
